import React, { createContext, useState, useContext } from 'react';

const PermissionsContext = createContext();

export const usePermissions = () => useContext(PermissionsContext);

export const PermissionsProvider = ({ children }) => {
    const [permissions, setPermissions] = useState({});

    const hasPermission = (module, action) => {
        if (permissions.is_superuser) {
            return true;
        }
        const moduleName = module.toUpperCase();
        const perm = permissions[moduleName];
        return perm ? perm[action] : false;
    };

    const value = {
        permissions,
        setPermissions,
        hasPermission
    };

    return (
        <PermissionsContext.Provider value={value}>
            {children}
        </PermissionsContext.Provider>
    );
};